<template>
  <SpringCard class="review-card">
    <div
      class="review-card__header"
      :class="headerBgColor"
    >
      <div
        class="review-card__header-thumbnail"
        :style="{backgroundImage: `url(${avatarUrl})`}"
      />
      <div class="review-card__header-data">
        <h5 class="review-card__header-name">
          {{ name }}
        </h5>
        <h6 class="review-card__header-location">
          {{ address }}
        </h6>
        <h6 class="review-card__header-score">
          <span v-if="isFoundation">Credit Score:</span>
          <span v-else>Approved for:</span>
          <span :class="highlightTextColor"> {{ benefitValue }} </span>
        </h6>
      </div>
    </div>
    <div class="review-card__quote">
      <p> "{{ reviewQuote }}" </p>
    </div>
  </SpringCard>
</template>

<script>

import theme from '@/mixins/theme'
import { SpringCard } from 'spring-ui'

const EVERGREEN = parseInt(process.env.VUE_APP_TESTIMONIAL_ID_EVERGREEN_LOAN)
const PERSONAL_LOAN = parseInt(process.env.VUE_APP_TESTIMONIAL_ID_PERSONAL_LOAN)
const FOUNDATION = parseInt(process.env.VUE_APP_TESTIMONIAL_ID_FOUNDATION)
const MORTGAGE = parseInt(process.env.VUE_APP_TESTIMONIAL_ID_MORTGAGE)

export default {
  name: 'ReviewCard',

  components: {
    SpringCard
  },

  mixins: [theme],
  props: {
    avatar: {
      type: String,
      default: '',
      required: true
    },
    name: {
      type: String,
      default: '',
      required: true
    },
    address: {
      type: String,
      default: '',
      required: true
    },
    categoryId: {
      type: Number,
      required: true
    },
    reviewQuote: {
      type: String,
      required: true
    },
    benefitValue: {
      type: String,
      required: true
    }
  },

  computed: {
    headerBgColor () {
      switch (this.categoryId) {
        case EVERGREEN:
          return 'bg-green-50'
        case PERSONAL_LOAN:
          return 'bg-blue-50'
        case FOUNDATION:
          return 'bg-purple-50'
        case MORTGAGE:
          return 'bg-pink-50'
      }
      return 'bg-green-50'
    },
    highlightTextColor () {
      switch (this.categoryId) {
        case EVERGREEN:
          return 'text-green-500'
        case PERSONAL_LOAN:
          return 'text-blue-500'
        case FOUNDATION:
          return 'text-purple-500'
        case MORTGAGE:
          return 'text-pink-500'
      }
      return 'text-green-500'
    },
    avatarUrl () {
      if (!this.avatar) return
      return require(`@/assets/testimonials/${this.avatar}`)
    },
    isFoundation () {
      return this.categoryId === FOUNDATION
    }
  }
}
</script>

<style scoped lang="scss">
.review-card {
  @apply flex flex-col relative h-300 mb-20;

  @screen xs {
    @apply h-240;
  }

  @screen sm {
    @apply h-300;
  }

  @screen md {
    @apply max-w-350 min-w-350;
  }

  @screen lg {
    @apply max-w-320 min-w-320 h-240;
  }

  &__header {
    @apply grid items-center py-20 rounded-t-15 w-full;
    @apply gap-x-[20px];

    @screen xs {
      @apply p-20;
    }

    grid-template-columns: 105px 1fr;

    &-thumbnail {
      @apply h-95 w-95 rounded-10 bg-cover bg-center shadow ml-10;

      @screen xs {
        @apply ml-0 mr-15;
      }
    }

    &-data {
      @apply text-left flex flex-col h-full py-5 justify-between;
    }

    &-name {
      @apply font-bold;
    }

    &-location {
      @apply font-body text-sm;
    }

    &-score {
      @apply font-semibold text-md;
    }
  }

  &__quote {
    @apply p-20 pt-15 rounded-b-15 w-full max-h-110 text-left;
  }

  &__quote-product {
    @apply text-center;

    &::first-letter {
      @apply text-4xl;
    }
  }
}
</style>
